
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.091 22.5a.5.5 0 01-.354-.853l10.848-10.88a4.856 4.856 0 000-6.849A4.787 4.787 0 0018.173 2.5a4.786 4.786 0 00-3.413 1.418L2.176 16.539c-2.029 2.033-.922 3.581-.352 4.152a2.058 2.058 0 001.481.666A3.865 3.865 0 005.862 20l9.875-9.9a.5.5 0 01.708.706L6.57 20.7a4.8 4.8 0 01-3.265 1.654 3.061 3.061 0 01-2.189-.96c-1.257-1.259-1.825-3.382.352-5.564L14.051 3.212A5.785 5.785 0 0118.173 1.5a5.779 5.779 0 014.12 1.712 5.858 5.858 0 010 8.261l-10.848 10.88a.5.5 0 01-.354.147z"}})])
          )
        }
      }
    